import apiClient from './client';
import type { Medication } from '@/types/consultation';

export interface CreateMedicationData {
  name: string;
  dosageMg: number;
  frequencyHours: number;
}

export interface UpdateMedicationData {
  name?: string;
  dosageMg?: number;
  frequencyHours?: number;
}

class MedicationsService {
  async getAll(search?: string): Promise<Medication[]> {
    const params = search ? `?search=${encodeURIComponent(search)}` : '';
    const response = await apiClient.get(`/medications${params}`);
    return response.data;
  }

  async getById(id: string): Promise<Medication> {
    const response = await apiClient.get(`/medications/${id}`);
    return response.data;
  }

  async create(data: CreateMedicationData): Promise<Medication> {
    const response = await apiClient.post('/medications', data);
    return response.data;
  }

  async update(id: string, data: UpdateMedicationData): Promise<Medication> {
    const response = await apiClient.put(`/medications/${id}`, data);
    return response.data;
  }

  async delete(id: string): Promise<void> {
    await apiClient.delete(`/medications/${id}`);
  }
}

export const medicationsService = new MedicationsService();
